// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhj_wv bhj_iz bhj_xj bhj_i bhj_j bhj_q bhj_vr bhj_er bhj_sm bhj_sn bhj_eb","CommentsButton__icon":"il_b bhj_rx"};